let React = require('react');
import SectionSubpoemaLaw_en from './subpoena/subpoena_en';
import SectionSubpoemaLaw_es from './subpoena/subpoena_es';

let SectionSubpoemaLaw = React.createClass({

  render : function () {
    return (
      <div>
        {
          this.props.locale == "es" &&
          <SectionSubpoemaLaw_es />
        }
        {
          this.props.locale == "en" &&
          <SectionSubpoemaLaw_en />
        }
      </div>
    )
  }

})

export default SectionSubpoemaLaw;


// WEBPACK FOOTER //
// ./js/sectionSubpoemaLaw.js